import { edpApiV1 } from './index';

export const enum ReportType {
  Consultation = 'consultation',
  Document = 'document',
  Vacation = 'vacationApplication',
  Absence = 'absence',
  DayOff = 'dayOff',
}

export type ReportsRequest = {
  organizationIds?: string[];
  fromDate: string;
  toDate: string;
  type: ReportType;
};

export type ReportsResponse = {
  type: string;
};

export const reportsApi = edpApiV1.injectEndpoints({
  endpoints: build => ({
    reports: build.query<ReportsResponse, ReportsRequest>({
      query: params => ({
        url: '/v1/admin/hr/report/download-file',
        method: 'GET',
        params,
        responseHandler: async response => {
          const link = document.createElement('a');
          link.download = 'report';
          link.href = window.URL.createObjectURL(await response.blob());
          link.click();
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useReportsQuery, useLazyReportsQuery } = reportsApi;
